import React from 'react';
import Modal from '../modal/Modal';
import CustomSelect from '../inputs/CustomSelect';
import { ajax } from 'highed';
import PrimaryButton from '../buttons//PrimaryButton.tsx';
import { ButtonColor } from 'shared/buttons/models/ButtonModels';
import { colourStyles } from './PublishHelper';

class LiveSourceModal extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.onChange = this.onChange.bind(this);
    this.processGSheet = this.processGSheet.bind(this);
    this.showAdvancedSettings = this.showAdvancedSettings.bind(this);
    this.submit = this.submit.bind(this);
    this.loadGSheet = this.loadGSheet.bind(this);
    this.findRequestedSheet = this.findRequestedSheet.bind(this);
    this.onChangeLinkDataOptions = this.onChangeLinkDataOptions.bind(this);
    this.onChangeRefresh = this.onChangeRefresh.bind(this);

    this.state = {
      url: '',
      worksheet: '',
      startCells: '',
      endCells: '',
      showGoogle: false,
      error: false,
      badUrl: false,
      linkDataOptions: [
        {
          label: 'Google sheet',
          value: 'gsheet'
        },
        {
          label: 'CSV',
          value: 'csvURL'
        },
        {
          label: 'JSON (column ordered)',
          value: 'columnsURL'
        },
        {
          label: 'JSON (row ordered)',
          value: 'rowsURL'
        }
      ],
      linkDataValue: {
        label: 'Google sheet',
        value: 'gsheet'
      },
      refreshOptions: [
        {
          label: 'None',
          value: false
        },
        {
          label: '10 second',
          value: 10
        },
        {
          label: '30 seconds',
          value: 30
        },
        {
          label: '1 minute',
          value: 60
        },
        {
          label: '5 minutes',
          value: 300
        },
        {
          label: '10 minutes',
          value: 600
        },
        {
          label: '12 hours',
          value: 43200
        }
      ],
      refreshValue: {
        label: 'None',
        value: false
      }
    };
  }

  onChange(e) {
    this.setState({
      [e.target.getAttribute('data-input')]: e.target.value
    });
  }

  loadGSheet(key, gid) {
    let link = 'https://sheets.googleapis.com/v4/spreadsheets/';
    ajax({
      url: link + key + '?key=AIzaSyCchblEzIdk4rPKD6sbi72c4OseEdqmyPQ',
      success: (data) => {
        this.setState(
          {
            worksheet: this.findRequestedSheet(data, gid)
          },
          () => {
            this.processGSheet(key);
          }
        );
      },
      error: (e) => {
        if (e === 403) {
          this.setState({
            error: true
          });
        }
      }
    });
  }

  findRequestedSheet(data, gid) {
    if (data?.sheets && data.sheets.length) {
      // == is necessary for the check to work
      // eslint-disable-next-line eqeqeq
      const option = data.sheets.filter((opt) => opt.properties.sheetId == gid);

      if (option && option[0] && option[0].properties && option[0].properties.title !== '') {
        return option[0].properties.title;
      }
    }
    return '';
  }

  processGSheet(key) {
    if (key === '') return;

    const { startCells, endCells, refreshValue } = this.state;

    let options = {
      googleSpreadsheetKey: key
    };

    let start = startCells;
    let end = endCells;
    let worksheet = this.state.worksheet;

    let range = '';
    if (worksheet && worksheet !== '') range = worksheet + '!';

    range += (start || 'A1') + ':';
    range += end || 'ZZ';

    options.googleSpreadsheetRange = range;

    if (refreshValue.value !== false) {
      options.dataRefreshRate = refreshValue.value;
      options.enablePolling = true;
    }

    this.props.onHasData(options, 'google');
  }

  onChangeLinkDataOptions(selected) {
    this.setState({
      linkDataValue: selected
    });
  }

  onChangeRefresh(selected) {
    this.setState({
      refreshValue: selected
    });
  }

  showAdvancedSettings() {
    this.setState({
      showGoogle: !this.state.showGoogle
    });
  }

  loadLiveData() {
    const { linkDataValue, url, refreshValue } = this.state;

    const options = {
      [linkDataValue.value]: url
    };

    if (refreshValue.value !== false) {
      options.dataRefreshRate = refreshValue.value;
      options.enablePolling = true;
    }

    this.props.onHasData(options, 'live');
  }

  submit() {
    const { linkDataValue, url } = this.state;
    this.setState({
      badUrl: false,
      error: false
    });

    if (linkDataValue.value === 'gsheet') {
      const match = url.match(/https:\/\/docs.google.com\/spreadsheets\/d\/(.{44})\/edit#gid=(\d+)/);

      if (match) {
        this.loadGSheet(match[1], match[2]);
      } else {
        this.setState({ badUrl: true });
      }
      return;
    }

    // Live data
    this.loadLiveData();
  }

  render() {
    const { url, startCells, endCells, error, badUrl, linkDataOptions, linkDataValue, refreshOptions, refreshValue } =
      this.state;

    const { isChart } = this.props;
    const isGSheet = linkDataValue.value === 'gsheet';
    const hasError = error || badUrl;

    return (
      <Modal
        isOpen={this.props.isOpen}
        onClose={this.props.close}
        title={'Link data'}
        width={'w-7/12 max-w-xl'}
        bg={'bg-ev-yellow-1'}
        bodyClass={'px-8 py-6'}
        allowOverflow={true}
      >
        <div className="text-left">
          <div>
            <div className="pb-4">
              Connect a {isChart && <span>JSON or </span>}Google sheet. Make sure you’re on the correct datasheet when
              you copy/paste your url.
            </div>

            <div className={`font-bold ${hasError ? 'text-ev-red' : 'text-ev-dark-purple'}`}>
              {isGSheet ? 'Spreadsheet url' : 'Link'}
              {hasError && (
                <span>
                  <i className="pl-2 fa fa-info-circle" />
                </span>
              )}
            </div>

            <div className="pb-2">
              <input
                type="text"
                placeholder={isGSheet ? 'Enter a valid spreadsheet url' : 'Enter link'}
                className={`highed-imp-input-stretch highed-field-input ${hasError ? 'ring ring-ev-red' : ''}`}
                onChange={this.onChange}
                data-input="url"
                value={url}
              />
            </div>

            {isChart && (
              <div className="pb-4">
                <CustomSelect
                  styles={colourStyles}
                  label={'Data type:'}
                  options={linkDataOptions}
                  onChange={this.onChangeLinkDataOptions}
                  value={linkDataValue}
                />
              </div>
            )}

            {isGSheet && (
              <div className="flex gap-2">
                <div className="px-2 w-1/4 font-bold text-ev-dark-purple">
                  <div className="">Start cell</div>
                  <div className="">
                    <input
                      placeholder="Ex: A1"
                      className="highed-imp-input-stretch highed-field-input"
                      onChange={this.onChange}
                      data-input="startCells"
                      value={startCells}
                    />
                  </div>
                </div>

                <div className="px-2 w-1/4 font-bold text-ev-dark-purple">
                  <div className="">End cell</div>
                  <div className="">
                    <input
                      placeholder="Ex: ZZ"
                      className="highed-imp-input-stretch highed-field-input"
                      onChange={this.onChange}
                      data-input="endCells"
                      value={endCells}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>

          <hr />

          {isChart && (
            <>
              <div>
                <div className="font-bold text-lg text-ev-navy-blue-2 pb-4">Live data (optional)</div>

                <div className="pb-4">
                  Live data means that the published chart always load the latest version of data from your url. Refresh
                  time indicates how long after a user has loaded your site it&apos;ll refresh.
                </div>

                <div className="pb-6">
                  <CustomSelect
                    styles={colourStyles}
                    label={'Refresh time'}
                    options={refreshOptions}
                    onChange={this.onChangeRefresh}
                    value={refreshValue}
                  />
                </div>
              </div>

              <hr />
            </>
          )}

          <div className="highed-button-container pt-6 flex gap-2">
            <PrimaryButton onClick={this.submit} text="Connect my data" />
            <PrimaryButton onClick={this.props.close} text="Cancel" buttonColor={ButtonColor.BabyBlue} />
          </div>

          {error && (
            <div className="pt-2 font-bold text-ev-red">
              <span>
                <i className="pr-2 fa fa-info-circle" />
              </span>
              The sheet needs to be publically available.{' '}
              <a href="https://help.everviz.com/article/900-google-sheet-settings/" target="_blank" rel="noreferrer">
                Read more.
              </a>
            </div>
          )}

          {badUrl && (
            <div className="pt-2 font-bold text-ev-red">
              <span>
                <i className="pr-2 fa fa-info-circle" />
              </span>
              Please enter a valid spreadsheet URL.&nbsp;
              <a href="https://help.everviz.com/article/802-google-spreadsheet-import" target="_blank" rel="noreferrer">
                Read more.
              </a>
            </div>
          )}
        </div>
      </Modal>
    );
  }
}

LiveSourceModal.propTypes = {};

export default LiveSourceModal;
